import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';
import Search from '@ifeng-fe/ui_pc_search';
import Chip from 'Chip';

/**
 * for this page
 */
import TopNav from '../../../components/header';
import Logo from './logo/';
import MainNav from './nav/';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { nav, topAd, search, logo, mainNavData } = this.props.content;
        const SearchComp = errorBoundary(Search);
        const topNav = <TopNav key="topNav" content={nav} />;
        const topAdCon = (
            <div key="topAdCon" className={styles.ad}>
                <NoSSR onSSR={<div className={styles.box} />}>
                    <Ad content={topAd} styleName={styles.box} />
                </NoSSR>
            </div>
        );
        const topSearch = (
            <div className={styles.search} key="topSearch">
                <div className={styles.logo}>
                    <Chip id="170095" type="struct" title="Logo" groupName="头部" content={logo}>
                        <Logo content={logo} />
                    </Chip>
                </div>
                <Chip id="20005" type="struct" title="搜索" groupName="头部" content={search}>
                    <SearchComp />
                </Chip>
            </div>
        );
        const mainNav = (
            <Chip id="170092" type="struct" title="导航" groupName="头部" content={mainNavData} key={'mainNav'}>
                <MainNav content={mainNavData} />
            </Chip>
        );

        return [topNav, topAdCon, topSearch, mainNav];
    }
}

export default errorBoundary(Header);
